// ACTION TYPES
const name = 'params';
export const actionTypes = {
  SET_TICKER: `${name}:set_ticker`,
  SET_LOGGED_IN: `${name}:set_logged_in`,
  SET_EMAIL: `${name}:set_email`,
  SET_IS_STARTED: `${name}:set_is_started`,
};

// ACTIONS
export function setTicker(val) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_TICKER, value: val });
  };
}

export function setLoggedIn(val) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_LOGGED_IN, value: val });
  };
}

export function setEmail(val) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_EMAIL, value: val });
  };
}

export function setIsStarted(val) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_IS_STARTED, value: val });
  };
}



// WEBPACK FOOTER //
// ./src/actions/params.js